import React, { useState } from 'react';
import { Tabs } from '@b-design/fusion';
import $i18n from '@/i18n';
import MiniAppOnlineStatus from './component/miniAppOnlineStatus';
import CategoryManagement from './component/categoryManagement';
import MiniAppOperate from './component/miniAppOperate';
import MiniAppTemplate from './component/miniAppTemplate';
import './index.less';
import Header from './component/header';
import CalculateComponent from '@/components/CalculateComponent';
import store from '@/store';
import { isPublicDeploy } from '@/utils/config';

const MiniAppStore: React.FC = () => {
  // 内容区域高度
  const [, setContentHeight] = useState(200);
  const [spaceRoleState] = store.useModel('spaceRole');

  return (
    <div className="global-filter-list">
      <Header />
      <div className="detail-container">
        <Tabs shape="wrapped">
          {spaceRoleState?.roleList?.includes('ADMIN') && (
            <Tabs.Item
              title={$i18n.get({
                id: 'aopf.pages.miniAppStore.tabOnlineStatus',
                dm: '小程序上架&下架',
              })}
              key={'onlineStatus'}
            >
              <MiniAppOnlineStatus />
            </Tabs.Item>
          )}
          {spaceRoleState?.roleList?.includes('ADMIN') && (
            <Tabs.Item
              title={$i18n.get({
                id: 'aopf.pages.miniAppStore.tabCategoryManagement',
                dm: '类目管理',
              })}
              key={'categoryManagement'}
            >
              <CategoryManagement />
            </Tabs.Item>
          )}

          {spaceRoleState?.roleList?.includes('ADMIN') && (
            <Tabs.Item
              title={$i18n.get({
                id: 'aopf.pages.miniAppStore.tabMiniAppOperate',
                dm: '应用市场小程序运营',
              })}
              key={'miniAppOperate'}
            >
              <MiniAppOperate />
            </Tabs.Item>
          )}
          {isPublicDeploy() && (
            <Tabs.Item
              className="app-tab-free"
              title={
                <div className="app-tab">
                  {$i18n.get({
                    id: 'aopf.pages.miniAppStore.AppletTemplateLibrary',
                    dm: '小程序模板库',
                  })}
                  {/* <img
                 className="tab-free"
                 src={
                   $i18n.language === 'en-US'
                     ? 'https://gw.alicdn.com/imgextra/i4/O1CN01d1HYtI2399ONkj327_!!6000000007212-55-tps-38-38.svg'
                     : 'https://gw.alicdn.com/imgextra/i4/O1CN01F6gAVc1b6ZvOu3i39_!!6000000003416-55-tps-16-16.svg'
                 }
                /> */}
                  {/* <div>Free Now</div> */}
                  <div>{$i18n.get({ id: 'aopf.pages.miniAppStore.Free', dm: '限免' })}</div>
                </div>
              }
              key={'miniAppTemplate'}
            >
              <MiniAppTemplate />
            </Tabs.Item>
          )}
        </Tabs>
        <CalculateComponent
          otherWidth={280}
          otherHeight={88 + 48 + 56 + 56}
          windowChange={(_width, height) => {
            setContentHeight(height);
          }}
        />
      </div>
    </div>
  );
};
export default MiniAppStore;
